import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-payment-summary',
    templateUrl: './payment-summary.component.html',
    styleUrls: ['./payment-summary.component.scss'],
    standalone: false
})

export class PaymentSummaryComponent {
  @Input() amountDetails: any;
}
